const API_TOKEN = 'apiOnlineTokenAuthorization'
const API_SELLER_TOKEN = 'apiOnlineSellerTokenAuthorization'
const API_CUSTOMER_TOKEN = 'apiOnlineCustomerTokenAuthorization'

export default {
    API_TOKEN,
    API_SELLER_TOKEN,
    API_CUSTOMER_TOKEN,
}
